import React from 'react';
import { Form, Segment, Grid, Header } from 'semantic-ui-react';

// ─── Helpers ──────────────────────────────────────────────────────────────────

const CheckboxGroup = ({ label, name, options, formik }) => {
  const current = Array.isArray(formik.values[name])
    ? formik.values[name]
    : (formik.values[name] ? formik.values[name].split(',').map(s => s.trim()).filter(Boolean) : []);

  const toggle = (val) => {
    const next = current.includes(val)
      ? current.filter(v => v !== val)
      : [...current, val];
    formik.setFieldValue(name, next);
  };

  return (
    <Form.Field>
      {label && <label><strong>{label}</strong></label>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', marginTop: '0.4rem' }}>
        {options.map(opt => (
          <Form.Checkbox
            key={opt.value}
            label={opt.label}
            checked={current.includes(opt.value)}
            onChange={() => toggle(opt.value)}
          />
        ))}
      </div>
    </Form.Field>
  );
};

const SectionHeader = ({ letter, title }) => (
  <Segment inverted color='teal' style={{ marginTop: '1.5rem', marginBottom: '0.5rem' }}>
    <Header as='h4' style={{ margin: 0 }}>
      {letter}. {title}
    </Header>
  </Segment>
);

// Remplace <Divider horizontal> : trait à gauche, aligné à gauche
const QLabel = ({ children }) => (
  <div style={{
    marginTop: '1.2rem',
    marginBottom: '0.6rem',
    borderLeft: '3px solid #00b5ad',
    paddingLeft: '0.7rem',
    paddingBottom: '0.3rem',
    borderBottom: '1px solid rgba(34,36,38,.1)',
  }}>
    <strong style={{ color: '#444', fontSize: '0.9em' }}>{children}</strong>
  </div>
);

// ─── Checkbox option sets ─────────────────────────────────────────────────────

const AREATYPE_OPTIONS = [
  { value: 'mistura', label: 'Mistura (rezidensial no agrikultura uma-hun)' },
  { value: 'rezidensial', label: 'Rezidensial' },
  { value: 'agrikultura', label: 'Area agrikultura (toos, natar, viveiru, hakiak animal nst)' },
  { value: 'komunitaria', label: 'Propriedade komunitaria no zona protezida (ai-laran, fatin komunidade)' },
  { value: 'komersiu', label: 'Espasu komersiu (kiost, loja, fatin negosiu, fo arenda nst)' },
  { value: 'publiku_privadu', label: 'Edifisiu/eskritoriu Publiku no Privadu' },
  { value: 'abandonadu', label: 'Rai abandonadu' },
  { value: 'nst', label: 'Nst' },
];

const LANDTYPE_OPTIONS = [
  { value: 'sinal_konstrusaun', label: 'Sinal Konstrusaun ruma (uma fatin antigu, monumentu nst)' },
  { value: 'konstrusaun_atual', label: 'Konstrusaun atual (Uma, bee matan, kiost nst)' },
  { value: 'produtu_plantasaun', label: 'Produtu/plantasaun (ai-han, ai-fuan, ai-horis, animal, kolam nst)' },
  { value: 'semeteriu', label: 'Semeteriu, uma lisan, fatin halo ritual nst' },
  { value: 'bee_matan', label: 'Bee matan no irigasaun' },
  { value: 'nst', label: 'Nst' },
];

const ACTORS_OPTIONS = [
  { value: 'individu_individu',    label: 'Entre Individu ho Individu' },
  { value: 'individu_komunidade',  label: 'Entre Individu ho Komunidade' },
  { value: 'individu_estado',      label: 'Entre Indivídu ho Estado' },
  { value: 'komunidade_estado',    label: 'Entre Komunidade ho Estado' },
  { value: 'komunidade_kompania',  label: 'Entre Komunidade ho Empreza Privada' },
  { value: 'asosiasaun_governu',   label: 'Entre Asosiasaun ka Fundasaun ho Estado' },
  { value: 'komunidade_igreija',   label: 'Entre Komunidade ho Organizasaun Relijioza' },
  { value: 'komunidade_autoridade',label: 'Entre Komunidade ho Autoridade Lokal ka Lider Komunitariu' },
  { value: 'nst',                  label: 'Nst' },
];

const LEGALSTATUS_OPTIONS = [
  { value: 'propriedade_perfeita', label: 'Direitu Anteriores primariu — Propriedade Perfeita (titulu tempu portuges)' },
  { value: 'hakmilik', label: 'Direitu Anteriores primariu — Hakmilik (titulu tempu indonezia)' },
  { value: 'direitu_informal', label: 'Direitu Anteriores primariu — Direitu Informal da Propriedade (propriedade komunitariu)' },
  { value: 'aforamentu', label: 'Direitu Sekundariu — Aforamentu' },
  { value: 'hak_guna_bangunan', label: 'Direitu Sekundariu — Hak Guna Bangunan' },
  { value: 'hak_guna_usaha', label: 'Direitu Sekundariu — Hak Guna Usaha' },
  { value: 'kontratu_fan_sosa', label: 'Forma Akizisaun — Kontratu Fan no Sosa' },
  { value: 'susesaun', label: 'Forma Akizisaun — Susesaun tanba Mate/Eransa' },
  { value: 'uzukapiaun', label: 'Forma Akizisaun — Uzukapiaun (uza rai minimu tinan 20)' },
  { value: 'doasaun', label: 'Forma Akizisaun — Doasaun' },
];

const SECONDARYACTORS_OPTIONS = [
  { value: 'politiku', label: 'Politiku' },
  { value: 'polisia', label: 'Polisia' },
  { value: 'militar', label: 'Militar' },
  { value: 'autoridade_lokal', label: 'Autoridade Lokal no Lider Komunitariu' },
  { value: 'autoridade_igreija', label: 'Autoridade Igreija (Padre/Madre, Leigo, Katekista nst)' },
  { value: 'veteranu', label: 'Veteranu' },
  { value: 'broker', label: 'Broker' },
  { value: 'nst', label: 'Nst' },
];

const KSISUPPORT_OPTIONS = [
  { value: 'mediasaun', label: 'Mediasaun' },
  { value: 'refere_prosesu', label: 'Referé ba Prosesu Judisiáriu' },
  { value: 'sensibilizasaun', label: 'Sensibilizasaun Rejime Rai nian' },
  { value: 'konsolida_uniaun', label: 'Konsolida, mobiliza ba harii Uniaun' },
  { value: 'nst', label: 'Nst' },
];

const MUNICIPIO_OPTIONS = [
  { key: 'aileu',    value: 'Aileu',    text: 'Aileu' },
  { key: 'ainaro',   value: 'Ainaro',   text: 'Ainaro' },
  { key: 'baucau',   value: 'Baucau',   text: 'Baucau' },
  { key: 'bobonaro', value: 'Bobonaro', text: 'Bobonaro' },
  { key: 'cova_lima',value: 'Cova Lima',text: 'Cova Lima' },
  { key: 'dili',     value: 'Dili',     text: 'Dili' },
  { key: 'ermera',   value: 'Ermera',   text: 'Ermera' },
  { key: 'lautem',   value: 'Lautém',   text: 'Lautém' },
  { key: 'liquica',  value: 'Liquiçá',  text: 'Liquiçá' },
  { key: 'manatuto', value: 'Manatuto', text: 'Manatuto' },
  { key: 'manufahi', value: 'Manufahi', text: 'Manufahi' },
  { key: 'oecusse',  value: 'Oecusse',  text: 'Oecusse (RAEOA)' },
  { key: 'viqueque', value: 'Viqueque', text: 'Viqueque' },
];

const PARTE_INTERESADA_OPTIONS = [
  { value: 'individu', label: 'Individu' },
  { value: 'instituisaun_governu', label: 'Instituisaun Governu' },
  { value: 'igreija', label: 'Igreija' },
  { value: 'autoridade_lokal', label: 'Autoridade Lokal ka Lider Komunitariu' },
  { value: 'kompania_privada', label: 'Kompania Privada' },
];

// ─── Main form component ──────────────────────────────────────────────────────

export const ProjectInnerForm = ({ formik }) => {
  const { values, handleChange, handleBlur, setFieldValue } = formik;

  const field = (name, label, type = 'text', placeholder = '') => (
    <Form.Input
      label={label}
      name={name}
      type={type}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
    />
  );

  const textarea = (name, label, placeholder = '') => (
    <Form.TextArea
      label={label}
      name={name}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      rows={5}
    />
  );

  // ── A.1 ref_kazu inline composer ────────────────────────────────────────────
  const refParts = (values.ref_kazu || '').split('/');
  const refP1 = refParts[0] || '';
  const refP2 = refParts[2] || '';
  const refYear = refParts[3] || String(new Date().getFullYear());

  const handleRefChange = (p1, p2, yr) => {
    setFieldValue('ref_kazu', `${p1}/KSI ka Uniaun/${p2}/${yr}`);
  };

  // ── B.5b: vérifier si "individu" est coché ──────────────────────────────────
  const parteInteresadaCurrent = Array.isArray(values.parte_interesada_tipo)
    ? values.parte_interesada_tipo
    : (values.parte_interesada_tipo
        ? values.parte_interesada_tipo.split(',').map(s => s.trim()).filter(Boolean)
        : []);
  const showIndividuInput = parteInteresadaCurrent.includes('individu');

  const inputStyle = {
    padding: '0.4rem 0.5rem',
    border: '1px solid rgba(34,36,38,.15)',
    borderRadius: '4px',
    fontSize: '1em',
    fontFamily: 'inherit',
  };

  return (
    <div>

      {/* ══════════════ SECTION A ══════════════ */}
      <SectionHeader letter='A' title='INFORMASAUN JERÁL' />
      <Segment>

        {/* A.1 — Nú. Ref. Kazu */}
        <QLabel>A.1. Nú. Ref. Kazu</QLabel>
        <Form.Field>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'wrap' }}>
            <input style={{ ...inputStyle, width: '90px' }}
              value={refP1}
              onChange={e => handleRefChange(e.target.value, refP2, refYear)}
              placeholder='...'
            />
            <span style={{ whiteSpace: 'nowrap', color: '#555' }}>/KSI ka Uniaun/</span>
            <input style={{ ...inputStyle, width: '90px' }}
              value={refP2}
              onChange={e => handleRefChange(refP1, e.target.value, refYear)}
              placeholder='...'
            />
            <span style={{ color: '#555' }}>/</span>
            <input style={{ ...inputStyle, width: '70px' }}
              value={refYear}
              onChange={e => handleRefChange(refP1, refP2, e.target.value)}
              placeholder='202...'
            />
          </div>
          {values.ref_kazu && (
            <div style={{ marginTop: '0.4rem', color: '#888', fontSize: '0.85em' }}>
              {values.ref_kazu}
            </div>
          )}
        </Form.Field>

        {/* A.2 — Títulu Kazu */}
        <QLabel>A.2. Títulu Kazu *</QLabel>
        <Form.Input
          name='name'
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={formik.touched.name && formik.errors.name}
          placeholder='Ex: Disputa Bein Imovel iha...'
        />

        {/* A.3 — Lokalizasaun */}
        <QLabel>A.3. GPS Point — Lokalizasaun</QLabel>
        <Grid columns={4} stackable>
          <Grid.Column>
            <Form.Select
              fluid
              label='Munisipiu'
              value={values.municipality || ''}
              options={MUNICIPIO_OPTIONS}
              onChange={(_, { value }) => setFieldValue('municipality', value)}
              placeholder='Hili Munisipiu...'
            />
          </Grid.Column>
          <Grid.Column>{field('postu', 'Postu administrativu', 'text', 'Postu...')}</Grid.Column>
          <Grid.Column>{field('suku', 'Suku', 'text', 'Suku...')}</Grid.Column>
          <Grid.Column>{field('aldeia', 'Aldeia', 'text', 'Aldeia...')}</Grid.Column>
        </Grid>

        {/* A.4 — Utilizasaun */}
        <QLabel>A.4. Utilizasaun Bein Imovel Einkauza?</QLabel>
        <CheckboxGroup name='areatype' options={AREATYPE_OPTIONS} formik={formik} />

        {/* A.5 — Atividade */}
        <QLabel>A.5. Atividade iha Rai leten?</QLabel>
        <CheckboxGroup name='landtype' options={LANDTYPE_OPTIONS} formik={formik} />

      </Segment>

      {/* ══════════════ SECTION B ══════════════ */}
      <SectionHeader letter='B' title='DETALLU KONA-BA KRONOLOJIA KONFLITU' />
      <Segment>

        {/* B.1 — Parte sira */}
        <QLabel>B.1. Parte sira husi Disputa</QLabel>
        <CheckboxGroup name='actors' options={ACTORS_OPTIONS} formik={formik} />

        {/* B.2 — Área */}
        <QLabel>B.2. Rai ne'ebe disputa nia medida</QLabel>
        <Form.Input
          label='Área (hektare)'
          name='conflictarea'
          type='number'
          value={values.conflictarea || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ex: 2.5'
          width={4}
        />

        {/* B.3 — Baliza */}
        <QLabel>B.3. Konfrontasaun (baliza rai)</QLabel>
        <Grid columns={2} stackable>
          <Grid.Column>{field('boundary_north', 'Parte Norte (Tasi-Feto)', 'text', 'Baliza norte...')}</Grid.Column>
          <Grid.Column>{field('boundary_south', 'Parte Sul (Tasi-Mane)', 'text', 'Baliza sul...')}</Grid.Column>
          <Grid.Column>{field('boundary_east', "Parte Leste (Lorosa'e)", 'text', 'Baliza leste...')}</Grid.Column>
          <Grid.Column>{field('boundary_west', 'Parte Oeste (Loromonu)', 'text', 'Baliza oeste...')}</Grid.Column>
        </Grid>

        {/* B.4 — Komunidade afetadu */}
        <QLabel>B.4. Total komunidade afetadu</QLabel>
        <Grid columns={3} stackable>
          <Grid.Column>
            <Form.Input label='Total Uma Kain' name='impactedhouseholds' type='number'
              value={values.impactedhouseholds || ''} onChange={handleChange} onBlur={handleBlur} />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label='Total Membru Familia' name='impactedfamilymembers' type='number'
              value={values.impactedfamilymembers || ''} onChange={handleChange} onBlur={handleBlur} />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label='Feto' name='impactedwomen' type='number'
              value={values.impactedwomen || ''} onChange={handleChange} onBlur={handleBlur} />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label='Joven (17-35)' name='impactedyouth' type='number'
              value={values.impactedyouth || ''} onChange={handleChange} onBlur={handleBlur} />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label='Difisiente' name='impacteddisabled' type='number'
              value={values.impacteddisabled || ''} onChange={handleChange} onBlur={handleBlur} />
          </Grid.Column>
          <Grid.Column>
            <Form.Input label='Idozu' name='impactedelderly' type='number'
              value={values.impactedelderly || ''} onChange={handleChange} onBlur={handleBlur} />
          </Grid.Column>
        </Grid>

        {/* B.4a — Tuir Komunidade */}
        <QLabel>B.4a. Fundamentu kona-ba Estatutu Rai (bele hili liu ida)</QLabel>
        <CheckboxGroup
          label='Tipu klasifikasaun rai (bele hili liu ida)'
          name='legalstatusfarmerspov'
          options={LEGALSTATUS_OPTIONS}
          formik={formik}
        />
        {textarea('conflicthistory',
          'Istória Komunidade — Faktu Istóriku rai nian',
          'Haklean oitoan kona-ba faktu istóriku rai nian...'
        )}

        {/* B.4b — Identifikasaun Parte Benefisiária */}
        <QLabel>B.4b. Identifikasaun Parte Benefisiária</QLabel>
        <CheckboxGroup
          name='parte_interesada_tipo'
          options={PARTE_INTERESADA_OPTIONS}
          formik={formik}
        />
        {showIndividuInput && (
          <Form.TextArea
            label='Detallu Individu (naran, data moris, seksu, estadu sivil, hela fatin atual, nasionalidade, profisaun, kontaktu)'
            name='parte_interesada_individu'
            value={values.parte_interesada_individu || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder='Naran: ..., Data moris: ..., Seksu: ..., Estadu sivil: ..., Hela fatin: ..., Nasionalidade: ..., Profisaun: ..., Kontaktu: ...'
            rows={4}
          />
        )}

        {/* B.4c — Baze ba Parte Benefisiária */}
        <QLabel>B.4c. Baze ba Parte Benefisiária</QLabel>
        <CheckboxGroup
          label='Tipu fundamentu kona-ba estatutu rai (bele hili liu ida)'
          name='legalstatusotherpov'
          options={LEGALSTATUS_OPTIONS}
          formik={formik}
        />
        {textarea('ownershipproffotherpov',
          'Istória Parte Benefisiária — Faktu Istóriku rai nian',
          'Haklean oitoan kona-ba faktu istóriku husi parte benefisiária...'
        )}

        {/* B.5 — Ema terseiru */}
        <QLabel>B.5. Ema terseiru ne'ebe ameasa komunidade</QLabel>
        <CheckboxGroup name='secondaryactors' options={SECONDARYACTORS_OPTIONS} formik={formik} />

        {/* B.6 — Kronolojia */}
        <QLabel>B.6. Kronolojia Disputa Rai</QLabel>
        {textarea('juridicsituationclaming',
          '',
          'Prienxe detalla: notifikasaun husi governu/tribunal, eviksaun, konsultasaun, tribunal, ezijensia komunidade...'
        )}

      </Segment>

      {/* ══════════════ SECTION C ══════════════ */}
      <SectionHeader letter='C' title='ENVOLVIMENTU KSI ka UNIAUN' />
      <Segment>

        <QLabel>C.1. Horibainhira maka KSI/KNRA hahu nia intervensaun? (tinan)</QLabel>
        <Form.Input
          name='ksisupportstart'
          type='number'
          value={formik.values.ksisupportstart || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder='Ex: 2018'
          width={4}
        />

        <QLabel>C.2. Tipu apoiu KSI/Uniaun</QLabel>
        <CheckboxGroup name='ksisupporttype' options={KSISUPPORT_OPTIONS} formik={formik} />

        <QLabel>C.3. Informasaun adisionál (eventu ruma)</QLabel>
        <Form.TextArea
          name='additionalinformation'
          rows={4}
          placeholder='Informasaun seluk kona ba eventu ruma...'
          value={formik.values.additionalinformation || ''}
          onChange={formik.handleChange}
        />

      </Segment>

      {/* ══════════════ SECTION D ══════════════ */}
      <SectionHeader letter='D' title='INFORMASAUN KONA BA ENUMERADOR NO INFORMANTE' />
      <Segment>

        <QLabel>D.1. Informante</QLabel>
        <Grid columns={2} stackable>
          <Grid.Column>{field('informant_name', 'Naran', 'text', 'Naran kompletu...')}</Grid.Column>
          <Grid.Column>{field('informant_org', 'Baze/Organizasaun', 'text', 'Organizasaun...')}</Grid.Column>
          <Grid.Column>{field('informant_position', 'Pozisaun', 'text', 'Pozisaun/Funsaun...')}</Grid.Column>
          <Grid.Column>{field('informant_contact', 'Kontaktu', 'text', 'Telefone...')}</Grid.Column>
        </Grid>

        <QLabel>D.2. Enumerador</QLabel>
        <Grid columns={2} stackable>
          <Grid.Column>{field('enumerator_name', 'Naran', 'text', 'Naran kompletu...')}</Grid.Column>
          <Grid.Column>{field('enumerator_org', 'Baze/Organizasaun', 'text', 'Organizasaun...')}</Grid.Column>
          <Grid.Column>{field('enumerator_position', 'Pozisaun', 'text', 'Pozisaun/Funsaun...')}</Grid.Column>
          <Grid.Column>{field('enumerator_contact', 'Kontaktu', 'text', 'Telefone...')}</Grid.Column>
        </Grid>

      </Segment>
    </div>
  );
};
